module.exports = __webpack_public_path__ + "static/media/react.aabc95be.jpg";